import { render, staticRenderFns } from "./ComboManage.vue?vue&type=template&id=505af8e1&scoped=true&"
import script from "./ComboManage.vue?vue&type=script&lang=js&"
export * from "./ComboManage.vue?vue&type=script&lang=js&"
import style0 from "./ComboManage.vue?vue&type=style&index=0&id=505af8e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505af8e1",
  null
  
)

export default component.exports